module.exports = __webpack_public_path__ + "static/media/rsd.54214165.png";